import { render } from "./Login.vue?vue&type=template&id=0206f7b0"
import script from "./Login.vue?vue&type=script&lang=js"
export * from "./Login.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src689428801/src/mess-barcode-scan-req-serv/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__